import React from "react";
import { getISOWeekNumber } from "../../hooks/useDayCarousel";
import { toDateKey } from "./DashboardUtils";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "./WeekdayBar.css";

const WEEKDAY_LABELS = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];

const WeekdayBar = ({ weekDays, focusedIndex, cardsPerViewport, onDayTapped, onPrevWeek, onNextWeek }) => {
    const todayKey = toDateKey(new Date());
    const kwNumber = weekDays.length > 0 ? getISOWeekNumber(weekDays[0]) : "";

    return (
        <div className="weekday-bar">
            <button className="weekday-bar-nav" onClick={onPrevWeek} title="Vorherige Woche">
                <ChevronLeft size={16} />
            </button>
            <span className="weekday-bar-kw">KW {kwNumber}</span>
            {weekDays.map((day, i) => {
                const dayKey = toDateKey(day);
                const isToday = dayKey === todayKey;
                const isVisible = i >= focusedIndex && i < focusedIndex + cardsPerViewport;

                let pillClass = "weekday-pill";
                if (isVisible && isToday) pillClass += " weekday-pill--today";
                else if (isVisible) pillClass += " weekday-pill--active";

                return (
                    <div
                        key={dayKey}
                        className={pillClass}
                        onClick={() => onDayTapped(i)}
                    >
                        <span className="weekday-pill-label">{WEEKDAY_LABELS[i]}</span>
                        <span className="weekday-pill-date">{day.getDate()}</span>
                    </div>
                );
            })}
            <button className="weekday-bar-nav" onClick={onNextWeek} title="Nächste Woche">
                <ChevronRight size={16} />
            </button>
        </div>
    );
};

export default WeekdayBar;
